import styled, { keyframes } from 'styled-components';
import Particles from "@tsparticles/react";

export const mainContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
    position: relative;
    overflow-y: auto;
    background-color: var(--palette-one-dark-white);
    color: var(--palette-one-blue);
    z-index: 1;

    &::-webkit-scrollbar {
        width: 0;
    }
`;
export const loginHeader = styled.div`
    width: 90%;
    align-self: center;
    height: 60px;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
export const logo = styled.img`
    width: 200px;
    margin: 0 20px;
    cursor: pointer;
    transition: 0.3s;

    @media (max-width: 500px) {
        width: 150px;
    }
`;
export const headerButtonsWrapper = styled.div`
    display: flex;
    gap: 20px;

    @media (max-width: 500px) {
        gap: 10px;
        flex-direction: column;
    }
`;
export const headerButton = styled.h2`
    cursor: pointer;
    font-size: 1.15rem;
    font-weight: 500;
    transition: 0.3s;
    text-transform: uppercase;
    border-radius: 5px;
    &:hover {
        text-decoration: underline;
        transform: scale(1.1);
    }

    @media (max-width: 500px) {
        font-size: 1rem;
        text-align: right;
    }
`;
export const mainInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 50px;
    position: relative;
    margin: 50px 0 20px 0;

    @media (max-width: 900px) {
        flex-direction: column;
    }

    @media (max-width: 500px) {
        margin: 50px 0 0 0;
    }
`;
export const ctaArea = styled.div`
    display: flex;
    flex-direction: column;
    z-index: 1;
    position: relative;
    gap: 40px;
    align-self: center;
    width: 40%;
    height: max-content;

    @media (max-width: 900px) {
        width: 85%;
    }

    @media (max-width: 500px) {
        gap: 30px;
    }
`;
export const imageArea = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 40%;
    height: 100%;
    position: relative;
    z-index: 1;
`;
export const mainImage = styled.img`
    width: 100%;
    height: auto;
    max-width: 500px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 0px rgba(255, 255, 255, 0.60);

    @media (max-width: 1366px) {
        max-width: 400px;
    }

    @media (max-width: 900px) {
        display: none;
    }
`;
export const mainTitle = styled.h1`
    font-size: 3.2rem;
    font-weight: 700;
    text-align: left;
    border-radius: 5px;

    @media (max-width: 1366px) {
        font-size: 2.25rem;
    }
    @media (max-width: 900px) {
        font-size: 1.8rem;
        text-align: center;
    }
    @media (max-width: 500px) {
        font-size: 1.5rem;
    }
`;
export const subTitle = styled.h2`
    font-size: 1.3rem;
    width: 100%;
    text-align: left;

    @media (max-width: 1366px) {
        font-size: 1.2rem;
    }
    @media (max-width: 900px) {
        font-size: 1.1rem;
        text-align: center;
    }
    @media (max-width: 500px) {
        font-size: 1rem;
    }
`;
const shadowPulseAnimation = keyframes`
    0% {
        box-shadow: 0px 0px 0px 0px rgba(36, 123, 160, 0.60);
    }

    100% {
        box-shadow: 0px 0px 0px 15px rgba(36, 123, 160, 0);
    }
`;

export const pageTitle = styled.h1`
    font-size: 2rem;
    font-weight: 700;
    text-align: center;
    margin: 70px 0 20px 0;
    color: var(--palette-one-blue);

    @media (max-width: 900px) {
        width: 85%;
        align-self: center;
        margin: 50px 0 20px 0;
    }
`;

export const startCta = styled.h3`
    font-size: 1.5rem;
    text-transform: uppercase;
    font-weight: 500;
    cursor: pointer;
    padding: 10px 100px;
    transition: color 0.3s ease;
    background-color: var(--palette-one-blue);
    color: #FFFCFF;
    border-radius: 2px;
    transition: 0.3s;
    text-align: center;
    align-self: flex-start;
    animation: ${shadowPulseAnimation} 2s infinite;

    &:hover {
        transform: scale(1.025);
    }

    @media (max-width: 900px) {
        padding: 10px 150px;
        font-size: 1.2rem;
        align-self: center;
    }

    @media (max-width: 500px) {
        padding: 10px 75px;
        font-size: 1rem;
    }
`;
export const infobitsArea = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 85%;
    align-self: center;
    margin: 100px 0 100px 0;
    justify-content: center;
    text-align: center;
    z-index: 1;
    gap: 60px;

    @media (max-width: 500px) {
        margin: 75px 0 75px 0;
    }
`;
export const infobit = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1 1 350px;
    align-self: stretch;
    gap: 10px;
    background-color: var(--palette-one-dark-white);
    border-radius: 10px;
    color: var(--palette-one-blue);

    @media (max-width: 850px) {
        flex: 1 1 200px;
    }
`;
export const infobitTitle = styled.h2`
    font-size: 1.25rem;
    font-weight: 600;
    width: 100%;
    text-align: start;
    border-bottom: 2px solid var(--palette-one-blue);
`;
export const infobitSubtitle = styled.h3`
    font-size: 1rem;
    font-weight: 400;
    text-align: start;
`;
export const persuasiveInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: center;
    justify-content: space-between;
    width: 85%;
    z-index: 1;
    margin: 50px 0;
    gap: 150px;

    @media (max-width: 1366px) {
        gap: 75px;
    }

    @media (max-width: 900px) {
        flex-direction: column-reverse;
    }

    @media (max-width: 500px) {
        gap: 50px;
        margin: 20px 0;
    }

    &.reverse {
        flex-direction: row-reverse;

        @media (max-width: 900px) {
            flex-direction: column-reverse;
        }
    }
`;
export const persuasiveTextArea = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
`;
export const persuasiveTitle = styled.h2`
    font-size: 2.25rem;
    font-weight: 600;
    margin-bottom: 20px;

    @media (max-width: 1366px) {
        font-size: 1.80rem;
    }

    @media (max-width: 500px) {
        font-size: 1.5rem;
    }
`;
export const persuasiveText = styled.p`
    font-size: 1.25rem;
    font-weight: 400;
    line-height: 1.5;

    @media (max-width: 1366px) {
        font-size: 1.15rem;
    }

    @media (max-width: 500px) {
        font-size: 1rem;
    }
`;
export const persuasiveImage = styled.img`
    max-width: 400px;
    height: auto;
    border-radius: 10px;
    
    @media (max-width: 1366px) {
        max-width: 300px;
    }

    @media (max-width: 900px) {
        max-width: 85%;
    }
`;
export const particles = styled(Particles)`
    z-index: 0;
    position: absolute;
`;
export const lastCtaText = styled.h1`
    font-size: 2rem;
    font-weight: 700;
    text-align: center;
    align-self: center;
    margin: 70px 0 50px 0;
    width: 30%;
    color: var(--palette-one-blue);

    @media (max-width: 1366px) {
        width: 50%;
    }

    @media (max-width: 900px) {
        width: 70%;
    }

    @media (max-width: 500px) {
        width: 85%;
        font-size: 1.5rem;
    }
`;
export const lastCta = styled.h3`
    font-size: 1.5rem;
    text-transform: uppercase;
    font-weight: 500;
    cursor: pointer;
    padding: 10px 50px;
    margin: 0 0 50px 0;
    align-self: center;
    transition: color 0.3s ease;
    background-color: var(--palette-one-blue);
    color: #FFFCFF;
    border-radius: 2px;
    transition: 0.3s;
    text-align: center;
    animation: ${shadowPulseAnimation} 2s infinite;

    &:hover {
        transform: scale(1.025);
    }

    @media (max-width: 800px) {
        padding: 10px 100px;
        font-size: 1.2rem;
    }

    @media (max-width: 500px) {
        padding: 10px 75px;
        font-size: 1.1rem;
        margin: 0 0 30px 0;
    }
`;
export const footer = styled.footer`
    width: 100%;
    padding: 15px 0;
    margin-top: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--palette-one-blue);
    color: var(--palette-one-white);
`;